import {styled} from 'styled-components';
import {Route} from 'wouter';

import {Modal} from '@shared-web/components/core/modal';

import {ChampionOverviewPage} from '@src/pages/champion_overview_page';
import {ChampionsPickPage} from '@src/pages/champions_pick_page';
import {DefaultPage} from '@src/pages/default_page';
import {TeamMetaPage} from '@src/pages/team_meta_page';
import {TeamOverviewPage} from '@src/pages/team_overview_page';

export const App: React.FC = () => {
  const routes = (
    <>
      <Route path="/pick" component={ChampionsPickPage} />
      <Route path="/overview" component={TeamOverviewPage} />
      <Route path="/meta/:model" component={TeamMetaPage} />
      <Route path="/champion/:championName" component={ChampionOverviewPage} />
      <Route path="/" component={DefaultPage} />
    </>
  );

  return (
    <Route path="/" nest>
      <>
        <Wrapper>{routes}</Wrapper>
        <Modal />
      </>
    </Route>
  );
};
App.displayName = 'App';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
`;
